const chapters = [
  ["01", "Any bicycle, one source", "Leisure rides, road racing, gravel miles or daily utility — start with a category, not a supply-chain maze."],
  ["02", "One part is enough", "The catalogue is built for the practical moment: one replacement, a matched set or the quantity your shop actually needs."],
  ["03", "The number stays visible", "Prices are shown in Canadian dollars per unit so the choice feels clear before you reach checkout."],
  ["04", "A cleaner hand-off", "Your address, shipping and acknowledgement come together in one secure Stripe checkout, ready for the next job."],
];

export default function ManifestoSection() {
  return (
    <section className="manifesto-section content-section" data-testid="manifesto-chapters-section">
      <div className="manifesto-intro"><p className="eyebrow">04 / Direct by design</p><h2>Good parts should<br /><em>move simply.</em></h2><p>We keep the buying decision close to the part: clear records, a practical quantity and one direct path to the bench.</p></div>
      <div className="manifesto-grid">{chapters.map(([number, title, body]) => <article className="manifesto-card" key={number} data-testid={`manifesto-chapter-card-${number}`}><span>{number}</span><h3>{title}</h3><p>{body}</p></article>)}</div>
    </section>
  );
}
